import { render } from "./ScoreGroupsPanel.vue?vue&type=template&id=1cb52f2e&ts=true"
import script from "./ScoreGroupsPanel.vue?vue&type=script&lang=ts"
export * from "./ScoreGroupsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__